import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  DeletePlannerActions as Actions,
  DeletePlannerRequestAction as RequestAction,
} from 'store/ducks/planners';

export function* deletePlannerRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.delete, `planners/${id}`);
    onSuccess && onSuccess();
    notify('success', 'Planejador removido com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
